import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import IcoLock from "../../assets/img/IcoLock";
import IcoBack from "../../assets/img/IcoBack";
import { useAlert } from "../../shared/components/AlertProvider";
import Button from "../../shared/components/Button";
import Card from "../../shared/components/Card";
import CheckBox from "../../shared/components/CheckBox";
import Flex from "../../shared/components/Flex";
import Input from "../../shared/components/Input";
import Padding from "../../shared/components/Padding";
import Spacer from "../../shared/components/Spacer";
import Text from "../../shared/components/Text";
import HeaderStyle from "../common/css/Header.module.css";
import { responseMsg } from "../common/ResponseMsg";

function Login() {
    const [isLoginOpen,setLoginOpen] = useState(true);
    const [lock, setLock] = useState(false);
    const {register, handleSubmit, reset, formState: { isSubmitting, isDirty, errors }} = useForm();
    const navigate = useNavigate();
    const [rememberMe, setRememberMe] = useState(false);
    const showAlert = useAlert();

    const loginOpen = () => {
        return (
            <>
                <form>
                    <Text weight="bold" size="lg" style={{ textAlign: "center" }}>Login</Text>
                    <Spacer direction="vertical" size={35} />
                    
                    <Input placeholder="아이디를 입력하세요" style={{ backgroundColor: "#F3F3F3"}} autoFocus {...register("userId")} 
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit(onSubmit)();
                                e.target.blur();
                            }
                        }}
                    />
                    <Spacer direction="vertical" size={16} />
                    <Input 
                        type="password" 
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit(onSubmit)();
                                e.target.blur();
                            }
                        }}
                        placeholder="비밀번호를 입력하세요" 
                        style={{ backgroundColor: "#F3F3F3"}} 
                        {...register("userPass")} 
                    />
                </form>

                <Spacer direction="vertical" size={16} />

                <Flex alignItems="center" gap={5}>
                    <CheckBox
                        id="rememberMe"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <label htmlFor="rememberMe" style={{ cursor: "pointer" }}>
                        <Text variant={"span"}>로그인 상태 유지</Text>
                    </label>
                </Flex>
                <Spacer direction="sero" size={25} />
                <Button
                    fullWidth
                    shape="round"
                    style={{ height: "58px" }}
                    variant="primary"
                    onClick={handleSubmit(onSubmit)}
                >
                    로그인
                </Button>
            </>
        )
    }

    const findPwOpen = () => {
        return (
            <>
                <form>
                    <Text weight="bold" size="lg" style={{ textAlign: "center" }}>비밀번호 재발급</Text>
                    <Spacer direction="vertical" size={35} />
                    
                    <Input placeholder="아이디를 입력하세요" style={{ backgroundColor: "#F3F3F3"}} autoFocus {...register("userId")} onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit(onPwSubmit)();
                                e.target.blur();
                            }
                        }} />
                    <Spacer direction="vertical" size={16} />
                    <Input type="email" placeholder="이메일를 입력하세요" style={{ backgroundColor: "#F3F3F3"}} {...register("email")} onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit(onPwSubmit)();
                                e.target.blur();
                            }
                        }} />
                </form>

                <Spacer direction="vertical" size={61} />
                <Button
                    fullWidth
                    shape="round"
                    style={{ height: "58px" }}
                    variant="primary"
                    onClick={handleSubmit(onPwSubmit)}
                >
                    비밀번호 재발급
                </Button>
            </>
        )
    }

    const changeMode = () => {
        if (lock) return;

        setLock(true);
        setLoginOpen(!isLoginOpen);
        // 화면 전환 시 input 내용 초기화
        reset();

        setTimeout(() => {
            setLock(false);
        }, 1000)
    }

    const onSubmit = (formData) => {
        const formDataObj = new FormData();
        Object.keys(formData).forEach(ele => formDataObj.set(ele,formData[ele]))

        formDataObj.append("remember-me", String(rememberMe));

        fetch("/api/login", {
            method : 'post',
            body: formDataObj
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.LOGIN_FAIL.code) {
                    showAlert({title: "경고", text: "로그인에 실패했습니다." , type: "warning"});

                } else if(json.code === responseMsg.LOGIN_SUCCESS.code) {
                    localStorage.setItem("USER",json.data);
                    navigate('/main');

                }  else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    const onPwSubmit = (formData) => {
            const formDataObj = new FormData();
            Object.keys(formData).forEach(ele => formDataObj.set(ele,formData[ele]))
    
            fetch("/api/system/users/tmp-password", {
                method : 'post',
                body: formDataObj
            })
                .then((res) => res.json())
                .then((json) => {
                    if (json.code === responseMsg.SUCCESS.code) {
                        showAlert({title: "알림", text: "이메일로 임시 비밀번호가 전송됐습니다."});
    
                    } else if(json.code === responseMsg.TMP_PASSWORD_FAIL.code) {
                        showAlert({title: "경고", text: responseMsg.TMP_PASSWORD_FAIL.message, type: "warning"});
    
                    } else if (json.code === responseMsg.FAIL.code) {
                        showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                    }
                })
                .catch((error) => {
                });
        }

    return (
        <div 
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                backgroundImage: "url('/images/login.png')",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                userSelect: "none",
                width: "100%",
                height: "100vh"
            }}
        >
            <div style={{ width: "252px", height: "77px" }}>
                <img src="/images/logo.png" alt="logo" />
            </div>
            <Card width={386} backgroundColor="#F5F5F5">
                <Padding padding={10}>
                    <Card>
                        <Padding paddingX={15} paddingY={20}>
                            <AnimatePresence mode="wait">
                            {isLoginOpen ? (
                                <motion.div
                                    key="login"
                                    initial={{
                                        opacity: 0,
                                        x: -40,
                                        scale: 0.97
                                    }}
                                    animate={{
                                        opacity: 1,
                                        x: 0,
                                        scale: 1
                                    }}
                                    exit={{
                                        opacity: 0,
                                        x: 40,
                                        scale: 0.97
                                    }}
                                    transition={{
                                        duration: 0.4,
                                        ease: [0.22, 1, 0.36, 1]
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {loginOpen()}
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="findPw"
                                    initial={{
                                        opacity: 0,
                                        x: -40,
                                        scale: 0.97
                                    }}
                                    animate={{
                                        opacity: 1,
                                        x: 0,
                                        scale: 1
                                    }}
                                    exit={{
                                        opacity: 0,
                                        x: 40,
                                        scale: 0.97
                                    }}
                                    transition={{
                                        duration: 0.4,
                                        ease: [0.22, 1, 0.36, 1]
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {findPwOpen()}
                                </motion.div>
                            )}
                        </AnimatePresence>

                        </Padding>

                    </Card>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "20px",
                            gap: 4,
                            cursor: "pointer"
                        }}
                    >

                        <button 
                            className={HeaderStyle["header-action-btn"]}
                            onClick={() => {
                                changeMode();
                            }}
                            
                            >
                            {isLoginOpen ? <IcoLock/> : <IcoBack />}
                            <Text variant="span">{isLoginOpen ? "비밀번호 재발급" : "로그인"}</Text>
                        </button>
                    </div>
                </Padding>
            </Card>
        </div>
    );
}

export default Login;